import React, { useEffect, useState, useRef } from "react"
import { useHistory, useLocation } from "react-router"
import AppointmentCalendar from "../../components/AppointmentCalendar"
import Modal from "react-bootstrap/Modal"
import Box from "@mui/material/Box"
import Toast from "../../components/Toast"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Paper from "@mui/material/Paper"
import {
  addInvoiceLink,
  addNewPatient,
  fetchAppointmentCounts,
  getAllCenters,
  getAppointmentByTypeOrStatus,
  getAppointmentsByQuery,
  getPatientDetail,
  getSmartSummaryData,
  updateAppointment,
} from "../../core/services/api"
import { IAppointmentDetail } from "../../core/services/models/AppointmentDetail"
import "./AppointmentsPage.scss"
import PendingAppointmentsComponent from "./components/PendingAppointmentsComponent"
import RMOPendingAppointmentComponent from "./components/RMOPendingAppointmentComponent"
import PrintCalender from "./components/PrintCalender/PrintCalender"
import { useDispatch, useSelector } from "react-redux"
import drawerAction from "../../core/store/actions/drawerAction"
import moment from "moment"
import NurseCalendar from "../../components/NurseCalendar"
import BedAllocationRequestComponent from "./components/BedAllocationRequestComponent"
import { MocUserRole } from "../../core/services/models/Enums"
import Button from "../../components/Button"
import BlockCalendar from "./components/BlockCalendar"
import defaultSurveyConfig from "pages/RMO/components/cancerTemplateForm/template"
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import InputField from "components/InputField"
import { bookbedbyId } from "core/services/api/bedManagementService"
import AppointmentCalendarUtils from "components/AppointmentCalendar/AppointmentCalenderUtils"
import { Popover } from "@mui/material"
import { getTemplatesByType } from "core/services/api/patientDiagnosisService"
import debounce from 'lodash/debounce'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { calculateAge } from "core/utils/date"


export default function AppointmentsPage() {
  const componentRef: any = useRef<any>(null)
  const dispatch = useDispatch()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const centerDetail = useSelector((state: any) => state?.user?.centerDetail)

  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? "patient-detail-popover" : undefined

  const [opens, setOpen] = useState<any>(false)
  const [reasons, setReason] = useState<any>()
  const [payment, setIsPayment] = useState<any>()
  const [sendpaymentLink, setSendPaymentLink] = useState<any>()
  const history = useHistory()
  const location = useLocation()

  const [colorCode, setColorCode] = useState<any>()

  const isConsultantsViewShown = useSelector(
    (state: any) => state.drawer?.isConsultantsViewShown
  )


  const [selectedMode, updateSelectedModeMain] = useState<string>("Day")
  const [selectedItem, updateSelectedItemMain] = useState<any>()

  const [patientName, setPatientName] = useState()

  const [slots, updateSlots] = useState([])

  const [NurseSlots, updateNurseSlots] = useState([])

  const [smartSummary, updateSmartSummary] = useState<any>()

  const [patientId, setPatientId] = useState<any>("")

  const [disableButton, setDisableButton] = useState<any>(false)

  const [paymentFilter, setPaymentFilter] = useState<string>("All")

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (paymentFilter !== "All") {
      const paid = paymentFilter === "Paid" ? "true" : "false"
      searchParams.set("paid", paid);
    } else {
      searchParams.delete("paid")
    }

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  }, [paymentFilter])

  useEffect(() => {
    if (patientId?.patientId) {
      getSmartSummaryData(patientId?.patientId)
        .then((res) => {

          updateSmartSummary(res?.data)
        })
        .catch((err) => {
          console.log("smart summary fetch for a patient fail", err)
        })
    }
    if (patientId) {
      const pid: any = patientId?.patientId ? patientId?.patientId : patientId
      getPatientDetail(pid)
        .then((res: any) => {
          updateGeneralConsentData(res)
        })
        .catch((err: any) => {
          setSurveyData({})
          console.log(err?.message)
        })
    }
  }, [patientId])

  function fetchSmartSummary() {
    getSmartSummaryData(patientId?.patientId)
      .then((res) => {

        updateSmartSummary(res?.data)
      })
      .catch((err) => {
        console.log("smart summary fetch for a patient fail", err)
      })
  }

  // function reloadAppointments() {
  //   updateAppointments(totalAppointments)
  // }

  function handleBedVacant() {
    let tempBody: any = {}

    tempBody["bedId"] = patientId?.bedId
    tempBody["roomId"] = patientId?.roomId
    tempBody["bedBookingStatus"] = "BOOKED"
    tempBody["bedIsVacant"] = true
    // let bookedSlots = [].concat(location?.pat?.bookedSlots)
    // bookedSlots = bookedSlots.concat(body?.bookedSlots)
    tempBody["bookedSlots"] = patientId?.bookedSlots
    bookbedbyId(patientId?.id, tempBody).then((res) => {
      // reloadAppointments()
      toggleDisplayToast({
        text: "Room and bed has been Edited successfully",
        type: "success",
      })
    })
  }

  useEffect(() => {
    if (patientId) {
      setPatientName(
        userRole !== MocUserRole.PATIENT
          ? patientId?.isVIP
            ? patientId?.mocId
            : patientId?.patientName
          : patientId?.patientName
      )
      //updateSlots

      updateSlots(
        patientId?.appointmentType === "IPD" &&
          patientId?.allottedBed?.slots?.length > 0
          ? patientId?.allottedBed?.slots
          : patientId?.slots
      )
    }
  }, [])

  useEffect(() => {
    userRole === MocUserRole.NURSE &&
      updateNurseSlots(patientId?.bookedSlots ? patientId?.bookedSlots : "")
  }, [])

  useEffect(() => {
    if (isConsultantsViewShown !== null) {
      if (isConsultantsViewShown) {
        setColorCode(
          patientId?.consultantColourCode
            ? patientId?.consultantColourCode
            : "#f86a7c"
        )
      } else {
        setColorCode(
          patientId?.centerColorCode ? patientId?.centerColorCode : "#f86a7c"
        )
      }
    }
  }, [isConsultantsViewShown])

  function hexToRgb(hex: any, opacity: any) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    if (result) {
      var r = parseInt(result[1], 16)
      var g = parseInt(result[2], 16)
      var b = parseInt(result[3], 16)
      return `rgba(${r},${g},${b},${opacity})`
    }
    return null
  }

  function renderHorizontalStepper() {

    return (
      <div className="col-md-12 col-lg-12 d-flex stepper-wrapper">
        <div className="divider-line col-9" />
        <div className="checked-in pointer">
          <div
            className="text-center"
            onClick={() =>
              patientId?.status === "BOOKED"
                ? onPatientChipButtonClick({
                  source: "checkIn",
                  patient: patientId,
                })
                : null
            }
          >
            <img
              className={`stepper-icon ${patientId?.arrivalTime ? "completed-filler" : ""
                }`}
              alt="stepper icon"
              src="../../assets/images/stepperIcon.svg"
            />
          </div>
          <div className="title">
            {patientId?.arrivalTime ? "Checked in" : "Check in"}
          </div>
          {patientId?.arrivalTime && (
            <div className="time">
              {moment(patientId?.arrivalTime, "HH:mm").format("hh:mm A")}
            </div>
          )}
        </div>

        <div className="consultation pointer">
          <div
            className="text-center"
            onClick={() =>
              patientId?.status === "ARRIVED"
                ? onPatientChipButtonClick({
                  source: "consultation",
                  patient: patientId,
                })
                : null
            }
          >
            <img
              className={`stepper-icon ${patientId?.engageTime ? "completed-filler" : ""
                }`}
              alt="stepper icon"
              src="../../assets/images/stepperIcon.svg"
            />
          </div>
          <div className="title">
            {patientId?.engageTime ? "In Consultation" : "Consultation"}
          </div>
          {patientId?.engageTime && (
            <div className="time">
              {moment(patientId?.engageTime, "HH:mm").format("hh:mm A")}
            </div>
          )}
        </div>

        <div className="checked-out pointer">
          <div
            className="text-center"
            onClick={() =>
              patientId?.engageTime !== null
                ? onPatientChipButtonClick({
                  source: "checkOut",
                  patient: patientId,
                })
                : null
            }
          >
            <img
              className={`stepper-icon ${patientId?.status !== "COMPLETED" ? "" : "completed-filler"
                }`}
              alt="stepper icon"
              src="../../assets/images/stepperIcon.svg"
            />
          </div>
          <div className="title">
            {patientId?.status === "COMPLETED" ? "Checked out" : "Check out"}
          </div>
          {patientId?.completedTime && (
            <div className="time">
              {moment(patientId?.completedTime, "HH:mm").format("hh:mm A")}
            </div>
          )}
        </div>
      </div>
    )
  }

  const handleSave = () => {
    const temp = { ...patientId }
    temp["reason"] = reasons
    setshows(false)
    // and CALL UPDATE API
    onPatientChipButtonClick({ source: source, patient: temp })
    setOpen(false)
  }

  const getTNM = (row: any, index: any) => {
    const keys = Object.keys(row)
    if (keys.length > 0) {
      const stageKey = keys.find((e: any) => e.includes("csStage"))
      return `${row[`${stageKey}`] ? row[`${stageKey}`] : "NA"}`
    } else {
      return "NA"
    }
  }
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    //fetch smart summary
    fetchSmartSummary()
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const frontDeskTabs = [
    { title: "OPD", icon: "../../assets/images/opd_white_icon.svg", value: "" },
    { title: "IPD", icon: "../../assets/images/ipd_white_icon.svg", value: "" },
    { title: "HC", icon: "../../assets/images/hc.svg", value: "" },
    { title: "SPR", icon: "../../assets/images/opd_white_icon.svg", value: "" },
  ]

  const [tabs, updateTabs] = useState(frontDeskTabs)
  const [blockCalender, setBlockCalendar] = useState(false)
  const [specialCalendar, setSpecialCalendar] = useState<any>()

  // { origin: '', value: false }

  const [selectedTab, updateSelectedTab] = useState("OPD")
  const [shows, setshows] = useState<any>(false)
  const [source, setSource] = useState<string>("")

  const [appointmentsCount, updateAppointmentsCount] = useState<any>()
  const [totalAppointments, updateTotalAppointments] =
    useState<Array<IAppointmentDetail>>()
  const [appointments, updateAppointments] =
    useState<Array<IAppointmentDetail>>()
  const [pendingAppointments, updatePendingAppointments] =
    useState<Array<IAppointmentDetail>>()

  const [displayToast, toggleDisplayToast] = useState<any>()
  const [generalConsentError, setGeneralConsentError] = useState<any>(false)
  const [show, setShow] = useState<boolean>(false)
  const [surveyData, setSurveyData] = useState<any>()
  const [generalConsentTemplate, setGeneralConsentTemplate] = useState<any>({})
  const [printCalender, setprintCalender] = useState(false)

  const [dateRange, updateDateRange] = useState()

  const [dropdownObj, setDropdown] = useState<any>()
  const [patientspl, setPatientSpl] = useState<any>()
  const slotDuration = 15

  const [pendingBedAllocationRequests, updatePendingBedAllocation] =
    useState<any>()

  // State to track disabled state for each appointment
  const [disabledAppointments, setDisabledAppointments] = useState({});

  const fetchAppointmentsWithQuery = (dateRange: any) => {
    const searchParams = new URLSearchParams(location.search);
    const consultant = searchParams.get('consultant');
    const paymentFilter = searchParams.get('paid');

    let additionalQuery = ""
    if (consultant) {
      additionalQuery = `&consultantId=${consultant}`
    }
    if (paymentFilter) {
      additionalQuery += `&paid=${paymentFilter}`
      setPaymentFilter(paymentFilter === "true" ? "Paid" : "Unpaid")
    } else {
      setPaymentFilter("All")
    }

    fetchAppointmentsByRange(dateRange, additionalQuery)
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const consultantId = userDetail?.id;
    const consultant = searchParams.get('consultant');

    if (selectedTab === "Mine" && consultantId) {
      searchParams.set("consultant", consultantId);
    } else if (selectedTab === "All" && consultant === consultantId) {
      searchParams.delete("consultant")
    }

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  }, [selectedTab])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const consultantId = userDetail?.id;
    const consultant = searchParams.get('consultant');

    if (userRole === MocUserRole.CONSULTANT && selectedTab === "All" && consultant === consultantId) {
      updateSelectedTab("Mine")
    } else if (userRole === MocUserRole.CONSULTANT && consultant !== consultantId) {
      updateSelectedTab("All")
    }

    fetchAppointmentsWithQuery(dateRange)
  }, [location.search])

  useEffect(() => {
    fetchAppointmentsWithQuery(dateRange)
  }, [dateRange, userRole])

  // Function to update the disabled state for a specific appointment
  const setAppointmentDisabled = (appointmentId: any, isDisabled: boolean) => {
    setDisabledAppointments(prevState => ({
      ...prevState,
      [appointmentId]: isDisabled,
    }));
  };
  function onPatientChipButtonClick(event: any) {

    const appointmentId = event?.patient?.id;
    setAppointmentDisabled(appointmentId, true);
    if (event?.source === "reschedule") {
      toggleDisplayToast({
        text: `Clicking on reschedule will cancel the current appointment.\n Are you sure you want to continue?`,
        type: "warning",
        onClickText: "Reschedule",
        patient: event?.patient,
        appointmentId: appointmentId

      })

    } else if (event?.source === "reject") {
      toggleDisplayToast({
        text: `Are you sure you want to cancel the appointment?`,
        type: "warning",
        onClickText: "Yes",
        patient: event?.patient,
        appointmentId: appointmentId
      })


    } else if (event?.source === "noShow") {
      //update no show
      onStatusChange(event?.patient, "NO_SHOW")

    } else if (event?.source === "convertToIPD") {
      // toggleDisplayToast({
      //   text: `Clicking on convert to IPD will cancel the current appointment.\n Are you sure you want to continue?`,
      //   type: "warning",
      //   onClickText: "Convert To IPD",
      //   patient: event?.patient,
      // })
      let tempAppointment = Object.assign({}, event?.patient)
      tempAppointment["isConvertedToIpd"] = true
      delete tempAppointment["patientName"]
      delete tempAppointment["gender"]
      delete tempAppointment["age"]
      delete tempAppointment["primaryPhoneNumber"]
      delete tempAppointment["email"]
      delete tempAppointment["isVIP"]
      delete tempAppointment["allottedBed"]
      delete tempAppointment["invoiceId"]
      delete tempAppointment["isEditable"]
      delete tempAppointment["dob"]
      delete tempAppointment["medicalRecordsId"]
      delete tempAppointment["bedIsVacant"]
      delete tempAppointment["bedMadeVacantAt"]
      delete tempAppointment["mocAppointmentId"]
      delete tempAppointment["oldDocuments"]
      delete tempAppointment["serviceName"]
      delete tempAppointment["finalInvoiceAmount"]

      updateAppointment(tempAppointment)
        .then((res: any) => {
          setAppointmentDisabled(appointmentId, false);
          history.push(
            `/bookAppointment?patientId=${event?.patient?.patientId}&appointmentId=${event?.patient?.id}&source=${event?.source}`
          )
        })
        .catch((err: any) => {
          console.log(err?.message)
          setAppointmentDisabled(appointmentId, false);
          toggleDisplayToast({
            text: err?.response?.data?.message
              ? err?.response?.data?.message
              : "Unable to update appointment",
            type: "error",
          })
        })
    } else if (event?.source === "redirectToPatientDiagnosis") {
      history.push(
        `/patientDiagnosis/${event?.patient?.patientId}?appointmentId=${event?.patient?.id}`
      )
    } else if (
      event?.source === "checkIn" ||
      event?.source === "consultation" ||
      event?.source === "checkOut"

    ) {
      actionableStatus(event)
    } else if (event?.source === "billPayment") {
      //redirect to invoice id

      setAppointmentDisabled(appointmentId, false);
      history.push(`/invoices/patient/${event?.patient?.invoiceId}`)
    } else {
      //console.log("event", event)
    }
  }

  function actionableStatus(event: any) {

    if (
      userRole === MocUserRole.FRONT_DESK &&
      event?.patient?.appointmentType !== "HC"
    ) {
      makeStatusUpdateApiCall(event)
    } else if (
      (userRole === MocUserRole.HOME_CARE_RMO ||
        userRole === MocUserRole.HOME_CARE_NURSE) &&
      event?.patient?.appointmentType === "HC"
    ) {
      makeStatusUpdateApiCall(event)
    } else {
      toggleDisplayToast({
        text: `You don't have access to perform this action`,
        type: "warning",

      })
    }
  }

  function makeStatusUpdateApiCall(event: any) {
    //console.log(event, "makestaus")
    if (event?.source === "checkIn") {
      onStatusChange(event?.patient, "ARRIVED")
    } else if (event?.source === "consultation") {
      onStatusChange(event?.patient, "ONGOING")
    } else if (event?.source === "checkOut") {
      onStatusChange(event?.patient, "COMPLETED")
    }
  }
  interface ApiResponse {
    code: string
    message?: string
    data?: any
  }

  function onStatusChange(
    eachAppointment: any,
    status: string,
    redirectTo: any = null
  ) {
    setPatientId(eachAppointment?.patientId)
    if (
      (status !== "CANCELLED" &&
        moment(eachAppointment?.scheduleDate).isSame(
          moment().format("YYYY-MM-DD")
        )) ||
      status === "CANCELLED"
    ) {
      let tempAppointment = Object.assign({}, eachAppointment)
      tempAppointment.status = status
      delete tempAppointment["patientName"]
      delete tempAppointment["gender"]
      delete tempAppointment["age"]
      delete tempAppointment["primaryPhoneNumber"]
      delete tempAppointment["email"]
      delete tempAppointment["isVIP"]
      delete tempAppointment["allottedBed"]
      delete tempAppointment["invoiceId"]
      delete tempAppointment["isEditable"]
      delete tempAppointment["dob"]
      delete tempAppointment["medicalRecordsId"]
      delete tempAppointment["bedIsVacant"]
      delete tempAppointment["bedMadeVacantAt"]
      delete tempAppointment["mocAppointmentId"]
      delete tempAppointment["oldDocuments"]
      delete tempAppointment["serviceName"]
      delete tempAppointment["finalInvoiceAmount"]

      if (redirectTo === "rescheduled") {
        tempAppointment["isRescheduled"] = true
        tempAppointment["isRescheduledAndCancelled"] = true
      }

      // if (!tempAppointment?.isRescheduled) {
      //   tempAppointment?.isRescheduled === false
      // }
      handleUpdate(tempAppointment, redirectTo)
    } else {
      toggleDisplayToast({
        text: `You can only ${status === "ARRIVED"
          ? "check in"
          : status === "ONGOING"
            ? "consult"
            : status === "COMPLETED"
              ? "check out"
              : "perform this action"
          } for today.`,
        type: "error",
      })
    }
  }

  function handleUpdate(appointment: any, redirectTo: any = null) {
    // fetch data when check-in button is clicked
    const appointmentId = appointment?.id;
    setAppointmentDisabled(appointmentId, true);
    updateAppointment(appointment)
      .then((res: any) => {
        setDisableButton(false)
        if (redirectTo === "convertToIPD" || redirectTo === "rescheduled") {
          setAppointmentDisabled(appointmentId, false);
          history.push(
            `/bookAppointment?patientId=${appointment?.patientId}&appointmentId=${appointment?.id}&source=${redirectTo}`
          )
        } else {
          toggleDisplayToast({
            text: `Appointment has been ${appointment.status === "BOOKED"
              ? "approved"
              : appointment.status === "CANCELLED"
                ? "rejected"
                : "updated"
              } successfully.`,
            type: "success",
          })
          setAppointmentDisabled(appointmentId, false);
          setPatientId(res)
          fetchAppointmentsWithQuery(dateRange)
          dispatch(drawerAction.refreshAppointments(false))
          dispatch(drawerAction.refreshAppointments(true))
        }
      })
      .catch((err) => {
        setDisableButton(false)
        setAppointmentDisabled(appointmentId, false);
        const errCode = err?.response?.data?.code
        if (errCode === "GENERAL_CONSENT_IS_NOT_FILLED") {
          setGeneralConsentError(true)
        } else {
          toggleDisplayToast({
            text: err?.response?.data?.message
              ? err?.response?.data?.message
              : "Unable to update appointment",
            type: "error",
          })
        }
      })
  }

  useEffect(() => {
    let tempJson: any = {}
    getTemplatesByType("COMMON")
      .then((res: any) => {
        tempJson =
          res?.find((e: any) => e?.subType === "General Consent")?.data[0]
            ?.json || {}
        setGeneralConsentTemplate(tempJson)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    dispatch(
      drawerAction.setDrawerComponent({
        name: "CalendarDrawer",
      })
    )
    fetchAppointmentCount()

    return () => {
      dispatch(drawerAction.setDrawerComponent(null))
    }
  }, [])

  useEffect(() => {
    if (userRole) {
      if (
        userRole === MocUserRole.GENETIC_COUNSELLOR ||
        userRole === MocUserRole.PSYCHOLOGIST ||
        userRole === MocUserRole.CONSULTANT
      ) {
        let temp: any = [{ title: "All" }, { title: "Mine" }]
        updateTabs(temp)
        const searchParams = new URLSearchParams(location.search);
        const consultant = searchParams.get('consultant');
        const consultantId = userDetail?.id;
        let newConsultantTab = "Mine"
        if (consultant) {
          newConsultantTab = consultant === consultantId ? "Mine" : "All"
        }
        updateSelectedTab(newConsultantTab)
        fetchAllCenters()
      } else if (userRole === MocUserRole.FRONT_DESK) {
        updateTabs(frontDeskTabs)
        updateSelectedTab("OPD")
        dispatch(drawerAction.isConsultantsViewShown(true))
      } else {
        onDropdownChange("displayDropdown", false)
      }

      if (
        userRole === MocUserRole.RMO ||
        userRole === MocUserRole.NUTRITIONIST ||
        userRole === MocUserRole.PHYSIOTHERAPIST
      ) {
        dispatch(drawerAction.isConsultantsViewShown(true))
      }

      if (userRole === MocUserRole.CONSULTANT) {
        dispatch(drawerAction.isConsultantsViewShown(false))
      }

      if (userRole === MocUserRole.NURSE) {
        dispatch(drawerAction.isConsultantsViewShown(true))
        let query = `centerId=${userDetail?.currentCenter?.centerId
          }&appointmentType=IPD&status=WAITING_FOR_APPROVAL&startDate=${moment().format(
            "YYYY-MM-DD"
          )}`
        getAppointmentsByQuery(query)
          .then((res: any) => {
            const temp = res?.filter(
              (itm: any) => !itm?.allottedBed || itm?.allottedBed?.length === 0
            )
            updatePendingBedAllocation(temp)
          })
          .catch((err) => console.log("err in bed req fetch", err))
      }
    }
  }, [userRole])

  useEffect(() => {
    const ele: any = document.getElementById("patient-detail-popover")
    if (ele) {
      if (show) {
        if (ele) {
          ele.style.display = "none"
        }
      } else {
        if (ele) {
          ele.style.display = "block"
          ele.style.position = "absolute"
          ele.style.marginTop = "-370px"
          ele.style.marginLeft = "40px"
          ele.style.overflowY = "scroll"
        }
      }
    }
  }, [show])

  function fetchAllCenters() {
    getAllCenters()
      .then((res) => {
        const temp: any = Object.assign({}, { displayDropdown: true })
        const tempCenters: any = []
        userDetail?.centers?.map((eachUserCenter: any) => {
          const find = res?.find(
            (eachCenter: any) => eachCenter.id === eachUserCenter?.centerId
          )
          tempCenters.push(find)
        })
        temp["dropdownValues"] = tempCenters?.map((each: any) => {
          return { label: each?.centerName, value: each?.id }
        })
        // if (tempCenters && tempCenters[0] && tempCenters[0]?.id)
        //   temp["selected"] = tempCenters[0]?.id
        setDropdown(temp)
      })
      .catch((err) => console.log("err in fetch centers"))
  }

  function fetchAppointmentCount() {
    fetchAppointmentCounts(userDetail?.currentCenter?.centerId ? userDetail?.currentCenter?.centerId : centerDetail?.id)
      .then((res) => {
        updateAppointmentsCount(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  function fetchAppointmentsByRange(obj: any, additionalQuery?: string) {
    if (!obj?.startDate || !obj?.endDate) return

    let query = `startDate=${obj?.startDate}&endDate=${obj?.endDate}`
    query = query + `&centerId=${userDetail?.currentCenter?.centerId ? userDetail?.currentCenter?.centerId : centerDetail?.id}`

    if (additionalQuery) {
      query += additionalQuery
    }

    if (userRole === MocUserRole.HOME_CARE_RMO) {
      query = query + "&appointmentType=HC"
    }

    getAppointmentsByQuery(query)
      .then((res) => {
        updateTotalAppointments(
          res?.filter(
            (each) =>
              !each?.isRescheduled ||
              (each?.isRescheduled && each?.status !== "CANCELLED")
          )
        )
        if (userRole === MocUserRole.FRONT_DESK) {
          const opd = res?.filter(
            (each) =>
              each?.appointmentType === "OPD" &&
              ((!each?.isRescheduled && !each?.isSpecialRequest) ||
                (each?.isRescheduled && each?.status !== "CANCELLED")) &&
              (each?.status !== "CANCELLED")
          )?.length
          const ipd = res?.filter(
            (each) =>
              each?.appointmentType === "IPD" &&
              (!each?.isRescheduled ||
                (each?.isRescheduled && each?.status !== "CANCELLED")) &&
              each?.allottedBed?.slots?.length > 0 &&
              (each?.status !== "CANCELLED")
          )?.length
          const hc = res?.filter(
            (each) => each?.appointmentType === "HC" && !each?.isRescheduled
          )?.length
          const spr = res?.filter(
            (each) => each?.appointmentType === "OPD" && each?.isSpecialRequest && each?.status !== "CANCELLED"
          )?.length
          const valueObj = [
            {
              title: "OPD",
              value: opd ? opd : "0",
            },
            {
              title: "IPD",
              value: ipd ? ipd : "0",
            },
            {
              title: "HC",
              value: hc ? hc : "0",
            },
            {
              title: "SPR",
              value: spr ? spr : "0",
            },
          ]
          const tempTabs: Array<any> = [...tabs]
          const temp = tempTabs.map((item, i) =>
            Object.assign({}, item, valueObj[i])
          )
          updateTabs(temp)
        }
      })
      .catch((err) => {
        console.log("err", err)
        updateTotalAppointments([])
      })
  }

  useEffect(() => {
    if (userRole === MocUserRole.FRONT_DESK) {
      updateAppointmentsBasedOnServicetype()
    } else updateAppointments(totalAppointments)
  }, [selectedTab, totalAppointments])

  useEffect(() => {
    if (
      userRole === MocUserRole.GENETIC_COUNSELLOR ||
      userRole === MocUserRole.PSYCHOLOGIST ||
      userRole === MocUserRole.CONSULTANT
    ) {
      if (selectedTab === "All") {
        // all data
        onDropdownChange("displayDropdown", true)
        // make an api call to fetch center based appointments
        dispatch(drawerAction.isConsultantsViewShown(true))
      } else {
        //consultant's data
        onDropdownChange("displayDropdown", false)
        // make an api call to fetch consultant based appointments
        dispatch(drawerAction.isConsultantsViewShown(false))
      }
    }
  }, [selectedTab])

  useEffect(() => {
    if (dropdownObj?.selected) {
      fetchAppointmentsWithQuery(dateRange)
    }
  }, [dropdownObj?.selected])

  function updateAppointmentsBasedOnServicetype() {
    let tempFilter
    if (selectedTab === "SPR") {
      tempFilter = totalAppointments?.filter(
        (each) => each?.appointmentType === "OPD" && each?.isSpecialRequest
      )
    } else {
      tempFilter = totalAppointments?.filter(
        (each) =>
          each?.appointmentType?.toLowerCase() === selectedTab?.toLowerCase()
      )
    }

    updateAppointments(tempFilter)
  }

  function fetchAppointmentsByType(type: string) {
    let tempType = type?.toLowerCase() === "all" ? "" : type
    getAppointmentByTypeOrStatus(
      tempType,
      "WAITING_FOR_APPROVAL",
      userDetail?.currentCenter?.centerId ? userDetail?.currentCenter?.centerId : centerDetail?.id
    )
      .then((res) => {
        updatePendingAppointments(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  function handleFormComplete(data: any) {
    setSurveyData(data)
    handleOnSubmit(data)
  }

  const handleOnSubmit = (consentData: any) => {
    getPatientDetail(patientId)
      .then((res: any) => {
        const temp = { ...res }
        // temp["name"] = `${res?.firstName} ${res?.lastName}`
        temp["generalConsent"] = consentData
        temp["category"] = temp["category"]?.toUpperCase()
        if (temp["referredBy"] === "referredByOthers") {
          temp["referredBy"] = temp["referredByOthers"]
        }
        delete temp["ageString"]
        // delete temp["firstName"]
        // delete temp["lastName"]
        delete temp["referredByOthers"]
        delete temp["refunds"]
        delete temp["totalPendingInvoices"]
        delete temp["advancePayment"]
        delete temp["totalAdvancePayment"]
        delete temp["isEditedAlready"]
        delete temp["securityDeposit"]
        delete temp["totalPendingAmount"]
        delete temp["oldDocuments"]
        if (temp["documents"]) delete temp["documents"]

        addNewPatient(temp)
          .then((data: any) => {
            setShow(false)
            setPatientSpl(data)
            toggleDisplayToast({
              text: `Data saved successfully.`,
              type: "success",
            })
          })
          .catch((err) => {
            setShow(false)
            toggleDisplayToast({
              text: `Something went wrong, please try again later.`,
              type: "error",
            })
          })
      })
      .catch((err: any) =>
        toggleDisplayToast({
          text: `Something went wrong, please try again later.`,
          type: "error",
        })
      )
  }

  const updateGeneralConsentData = (data: any) => {
    const temp: any = { ...surveyData }
    temp["patientName"] = data?.isVIP ? data?.mocId : data?.name
    temp["name"] = data?.isVIP ? data?.mocId : data?.name
    setSurveyData(temp)
  }

  function renderBannerSection() {
    switch (userRole) {
      case MocUserRole.FRONT_DESK:
        return appointmentsCount &&
          appointmentsCount?.allPendingAppointments ? (
          <PendingAppointmentsComponent
            tabs={tabs}
            onPopupOpen={(event) => fetchAppointmentsByType(event)}
            appointments={pendingAppointments}
            appointmentsCount={appointmentsCount}
            userRole={userRole}
            centerDetail={centerDetail}
            onClose={() => null}
            disabledAppointments={disabledAppointments}
            onCancel={(event: any) =>
              onPatientChipButtonClick({
                source: "reject",
                patient: event,
              })
            }
            onReschedule={(event: any) =>
              onPatientChipButtonClick({
                source: "reschedule",
                patient: event,
              })
            }
            onToastDisplay={(event: any) => {
              toggleDisplayToast(event)
              fetchAppointmentCount()
              fetchAppointmentsWithQuery(dateRange)
              dispatch(drawerAction.refreshAppointments(false))
              dispatch(drawerAction.refreshAppointments(true))
            }}
          />
        ) : null

      case MocUserRole.RMO:
      case MocUserRole.CONSULTANT:
        return <RMOPendingAppointmentComponent />

      case MocUserRole.NURSE:
        return pendingBedAllocationRequests?.length > 0 ? (
          <BedAllocationRequestComponent
            requests={pendingBedAllocationRequests}
            history={history}
            userRole={userRole}
          />
        ) : null

      default:
        return null
    }
  }

  function renderTab(eachTab: any) {
    return (
      <div
        key={eachTab?.title}
        className={`tab ${selectedTab === eachTab?.title ? "active" : "inactive"
          } d-flex align-center`}
        onClick={() => {
          updateSelectedTab(eachTab?.title)
        }}
      >
        {eachTab?.icon && (
          <span className="icon col-3 p-0">
            <img
              src={eachTab?.icon}
              alt={eachTab?.title}
              width={30}
              height={30}
            />
          </span>
        )}
        <span className="col-9 text-center p-0">
          {eachTab.title} {eachTab?.value ? `[${eachTab?.value}]` : ""}
        </span>
      </div>
    )
  }

  function renderPrintButton() {
    return (
      <>
        <img
          src="../../assets/images/Group7951.svg"
          alt="print"
          onClick={() => setprintCalender(true)}
          className="printer_reponsive cursor-pointer"
        />
        <div>
          {printCalender === true && (
            <PrintCalender
              closePrintModal={setprintCalender}
              readOnly={userRole !== MocUserRole.NURSE}
              selectedItem={selectedItem}
              selectedMode={selectedMode}
            />
          )}
        </div>
      </>
    )
  }

  function onDropdownChange(source: any, value: any) {
    let t: any = Object.assign({}, dropdownObj)
    t[source] = value
    setDropdown(t)
  }


  let tempSpl = totalAppointments?.filter(
    (each) => each?.appointmentType === "OPD" && each?.isSpecialRequest
  )


  if (Array.isArray(tempSpl)) {
    tempSpl.sort((a, b) => {
      if (a.specialRequestFromTime < b.specialRequestFromTime) return -1;
      if (a.specialRequestFromTime > b.specialRequestFromTime) return 1;
      return 0;
    });

  }

  const invoiceFilterDropdown = () => (
    <DropdownButton
      title={paymentFilter}
      size="lg"
      variant="secondary"
      onSelect={(option: any) => {
        setPaymentFilter(option)
      }}>
      {["All", "Paid", "Unpaid"].map((dropdownItem, index) =>
        <Dropdown.Item
          key={`invoice-filter-${index}`}
          eventKey={dropdownItem}
        >{dropdownItem}</Dropdown.Item>
      )}
    </DropdownButton>
  )


  useEffect(() => {
    const element = document.getElementById("appointments-page-wrapper")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }, [])
  return (
    <div className="appointments-page-wrapper" id="appointments-page-wrapper">
      <div className="col-md-12 m-0 p-0">
        <div className="d-flex align-center welcome">
          <div className="welcomeText">
            Welcome Back !! - {userDetail?.name}
          </div>
          <div className="welcomeLocText">
            ({userDetail?.currentCenter?.brandName ? userDetail?.currentCenter?.brandName : userDetail?.currentCenter?.centerName})
          </div>
        </div>

        {/* PENDING APPOINTMENT SECTION */}
        {renderBannerSection()}

        {/* TAB HEADER SECTION */}
        {userRole === MocUserRole.FRONT_DESK ||
          userRole === MocUserRole.GENETIC_COUNSELLOR ||
          userRole === MocUserRole.PSYCHOLOGIST ||
          userRole === MocUserRole.CONSULTANT ? (
          <div className="d-flex justify-content-between align-center tab-section">
            <div className="tab-wrapper">
              {tabs?.map((eachTab) => renderTab(eachTab))}
            </div>

            <div>
              {invoiceFilterDropdown()}
            </div>

            {userRole !== MocUserRole.FRONT_DESK && (
              <div className="me-2" style={{ marginLeft: "386px" }}>
                <Button
                  text="Block Calendar"
                  onClick={() => setBlockCalendar(true)}
                  id="block-calender"
                />
              </div>
            )}
            {(userRole === MocUserRole.CONSULTANT ||
              userRole === MocUserRole.NUTRITIONIST ||
              userRole === MocUserRole.PSYCHOLOGIST ||
              userRole === MocUserRole.PHYSIOTHERAPIST ||
              userRole === MocUserRole.GENETIC_COUNSELLOR) && (
                <div className="ms-2 me-2">
                  <Button
                    text="Special Request"
                    onClick={() => setSpecialCalendar(true)}
                    id="specialrequest"
                  />
                </div>
              )}
            {userRole === MocUserRole.NURSE ||
              userRole === MocUserRole.FRONT_DESK ? (
              <>{renderPrintButton()}</>
            ) : (
              <></>
            )}

          </div>
        ) : (
          <div className="d-flex justify-content-between align-center">
            <div className="d-flex">
              {specialCalendar === true ? <div
                className="back-image"
                onClick={() => {
                  setSpecialCalendar(false)
                }}
              >
                <img
                  src="../../assets/images/back-icon.svg"
                  height={"60px"}
                  width={"60px"}
                  alt="back button"
                />
              </div> : ""}

              <div className="titleName" ref={componentRef}>
                Appointments
              </div>
            </div>

            <div className="d-flex justify-content-end">
              {userRole !== MocUserRole.NURSE &&
                userRole !== MocUserRole.HOME_CARE_NURSE && (
                  <div>
                    {invoiceFilterDropdown()}
                  </div>
                )}
              {userRole !== MocUserRole.NURSE &&
                userRole !== MocUserRole.RMO && (
                  <div className="ms-2 me-2">
                    <Button
                      text="Block Calendar"
                      onClick={() => setBlockCalendar(true)}
                      id="block-calender"
                    />
                  </div>
                )}

              {(userRole === MocUserRole.CONSULTANT ||
                userRole === MocUserRole.NUTRITIONIST ||
                userRole === MocUserRole.PSYCHOLOGIST ||
                userRole === MocUserRole.PHYSIOTHERAPIST ||
                userRole === MocUserRole.GENETIC_COUNSELLOR ||
                userRole === MocUserRole.RMO) && (
                  <div className="ms-2 me-2">
                    <Button
                      text="Special Request"
                      onClick={() => setSpecialCalendar(true)}
                      id="specialrequest"
                    />
                  </div>
                )}

              {userRole === MocUserRole.NURSE ||
                userRole === MocUserRole.FRONT_DESK ? (
                <>{renderPrintButton()}</>
              ) : (
                <></>
              )}
            </div>
          </div>
        )}

        {/* Appointment Calendar */}
        <div className="calendar-wrapper" ref={componentRef}>
          {userRole === MocUserRole.NURSE ? (
            <NurseCalendar
              centerDetail={centerDetail}
              userDetail={userDetail}
              userRole={userRole}
              reloadAppointments={appointments}
              // onButtonClick={(event: any) => onPatientChipButtonClick(event)}
              onPatientChipButtonClick={(event: any) => {
                if (
                  event?.patientId &&
                  event?.appointmentId &&
                  event?.arrivalTime
                ) {
                  history.push(
                    `/patientDiagnosis/${event?.patientId}?appointmentId=${event?.appointmentId}`
                  )
                }
              }}
              updateSelectedItemMain={updateSelectedItemMain}
            />
          ) : selectedTab === "SPR" || specialCalendar ? (
            showSpr()
          ) : (
            <AppointmentCalendar
              includeIpdOpdDivision={
                userRole !== MocUserRole.FRONT_DESK &&
                userRole !== MocUserRole.HOME_CARE_RMO
              }
              outline={
                userRole === MocUserRole.CONSULTANT ||
                userRole === MocUserRole.NUTRITIONIST ||
                userRole === MocUserRole.PHYSIOTHERAPIST
              }
              userRole={userRole}
              appointments={appointments}
              updateDateRange={updateDateRange}
              onButtonClick={(event: any) => {
                onPatientChipButtonClick(event)
              }}
              dropdown={dropdownObj}
              onDropdownChange={(event: any) =>
                onDropdownChange("selected", event)
              }
              centerDetail={centerDetail}
              reloadAppointments={appointments}
              updateSelectedModeMain={updateSelectedModeMain}
              updateSelectedItemMain={updateSelectedItemMain}
            />
          )}
        </div>
        {
          <Modal size="xl" show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                {generalConsentTemplate && (
                  <div className="general-consent-container">
                    <SurveyComponent
                      css={defaultSurveyConfig.defaultSurveyCSS}
                      data={surveyData}
                      json={generalConsentTemplate}
                      onComplete={(survey: any) => {
                        console.log(survey.data)

                        /** Save to a database */
                        /** Add to a spreadsheet, etc.... */
                        handleFormComplete(survey?.data)
                      }}
                      hideDot={true}
                    />
                  </div>
                )}
              </Box>
            </Modal.Body>
          </Modal>
        }
      </div>

      {displayToast ? (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => {
            toggleDisplayToast(false)
            setAppointmentDisabled(displayToast?.appointmentId, false);
          }}
          onCloseText="Close"
          onClickText={
            displayToast?.onClickText ? displayToast?.onClickText : null
          }
          disableClickButton={disableButton}
          onClick={() => {
            setDisableButton(true);

            const debouncedStatusChange = debounce(() => {
              if (displayToast?.patient) {
                onStatusChange(
                  displayToast?.patient,
                  "CANCELLED",
                  displayToast?.onClickText
                    ?.toLowerCase()
                    ?.includes("reschedule")
                    ? "rescheduled"
                    : displayToast?.onClickText
                      ?.toLowerCase()
                      ?.includes("convert to ipd")
                      ? "convertToIPD"
                      : null
                )
              }
            }, 300);

            debouncedStatusChange();
          }}
          type={displayToast?.type}
        />
      ) : generalConsentError ? (
        <Toast
          textMessage="To checkin patient, general consent should be filled first"
          onClose={() => {
            setGeneralConsentError(false)
          }}
          onCloseText="Close"
          onClickText="Click Here"
          onClick={() => {
            if (userRole === MocUserRole?.HOME_CARE_RMO) {
              setGeneralConsentError(false)
              setShow(true)
            } else {
              history.push(`/editPatient/${patientId}?isGeneralConsent=true`)
            }
          }}
          type="error"
        />
      ) : null}
      {blockCalender && (
        <BlockCalendar
          show={blockCalender}
          onClose={() => setBlockCalendar(false)}
          displayToast={(event: any) => {
            //setBlockCalendar(false)
            toggleDisplayToast(event)
          }}
        />
      )}
    </div>
  )

  function renderActionButtons() {
    function handleReason(e: any) {
      e.stopPropagation()
      e.preventDefault()
      setReason("")
      setshows(true)
    }

    return (
      <>
        {userRole !== MocUserRole.NURSE && (
          <div className="icon-buttons d-flex">
            {/* <div>
            {!patientId?.arrivalTime &&
              !(
                patientId?.appointmentType === "HC" &&
                userRole === MocUserRole?.FRONT_DESK
              ) ? (
              <img
                title="No show"
                alt="no-show"
                src="../../assets/images/noShowIcon.svg"
                onClick={(e: any) => handleNoshow(e)}
              />
            ) : (
              <></>
            )}
          </div> */}

            {!patientId?.engageTime && (
              <img
                title="Reject"
                alt="reject"
                src="../../assets/images/rejectIcon.svg"
                onClick={(e) => {
                  setSource("reject")
                  handleReason(e)
                }}
              />
            )}

            {/* {!patientId?.engageTime && (
            <img
              title="Reschedule"
              alt="reschedule"
              src="../../assets/images/rescheduleIcon.svg"
              onClick={() =>
                onPatientChipButtonClick({ source: "reschedule", patient: patientId })
              }
            />
          )} */}
          </div>
        )}

        <div>
          {shows && (
            <>
              <textarea
                value={reasons}
                onChange={(e: any) => {
                  const str = e.target.value

                  let code = str.charCodeAt(str.length - 1)
                  // const char = str[str.length - 1]
                  // let k = char.charCodeAt(0)
                  if (code === 10) {
                    const temp = { ...patientId }
                    temp["reason"] = reasons
                    setshows(false)
                    // and CALL UPDATE API
                    onPatientChipButtonClick({
                      source: source,
                      patient: temp,
                    })
                  }
                  setReason(e.target.value)
                }}
              />
              <div style={{ float: "right" }}>
                <Button text="Save" onClick={handleSave} />
              </div>
            </>
          )}
        </div>
      </>
    )
  }

  function renderSmartSummarySection() {
    return (
      <div
        className="card-view smart-summary"
        onClick={() =>
          onPatientChipButtonClick({
            source: "redirectToPatientDiagnosis",
            patient: patientId,
          })
        }
      >
        <div
          style={{ marginRight: "50px" }}
          className="icon col-md-1 col-lg-1 p-0"
        >
          <img
            alt="summaryIcon"
            src="../../assets/images/smartSummaryIcon.svg"
          />
        </div>
        <div className="col-md-11 col-lg-11">
          <div className="header">Smart Summary</div>
          <div className="col-md-12 col-lg-12">
            <div className="d-flex">
              <div className="p-0 title pt-2">Diagnosis:</div>&nbsp;&nbsp;
              <div className=" p-0 description pt-2">
                <div className="p-0 description" style={{
                  width: "250px",
                  textOverflow: "ellipsis"
                }}>
                  {smartSummary?.diagnosis?.length > 0 ? (
                    smartSummary?.diagnosis?.map((each: any) => {
                      return (
                        <li>
                          {each?.diagnosis}&nbsp;&nbsp;{each?.cancerType}
                        </li>
                      )
                    })
                  ) : (
                    <div>NA</div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="d-flex">
              <div className="p-0 title pt-2">Pending Amount:</div>&nbsp;&nbsp;
              <div className=" p-0 description pt-2">
                <div className="p-0 description">
                  {Number(smartSummary?.totalPendingAmount)?.toFixed(2)}
                </div>
              </div>
            </div> */}
            <div className="d-flex p-0">
              <div className="p-0 title mt-2">Last Visit:</div>&nbsp;&nbsp;
              <div className="p-0 description mt-2">
                <div className="p-0 description">
                  {smartSummary?.lastVisit === null
                    ? "-"
                    : moment(smartSummary?.lastVisit).format(
                      "DD-MM-YYYY, HH:mm "
                    )}
                </div>
              </div>
            </div>
            {/* <div className="col-md-6 col-lg-6 p-0 title mt-2">Last Visit:</div>
            <div className="col-md-2 col-lg-2 p-0 description">
              <span>{moment(smartSummary?.lastVisit).format("LLL")}</span>
            </div> */}
          </div>
          <div className="d-flex">
            <div className="p-0 title pt-2">Stage:</div>&nbsp;&nbsp;
            <div className=" p-0 description pt-2">
              <div className="p-0 description">
                {smartSummary?.stage?.length > 0 ? (
                  smartSummary?.stage?.map((each: any, index: any) => {
                    return (
                      <li>
                        {getTNM(each, index)}&nbsp;&nbsp;{smartSummary?.diagnosis[index]?.cancerType}
                      </li>
                    )
                  })
                ) : (
                  <div>NA</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  function renderBedDetails() {
    return (
      <div className="card-view smart-summary">
        <div className="col-md-11 col-lg-11">
          <div className="header">Bed Management</div>
          <span>
            Bed Made VacantAt:&nbsp;
            {patientId?.bedMadeVacantAt === null
              ? "-"
              : moment(patientId?.bedMadeVacantAt).format(
                "DD-MM-YYYY HH:mm:ss"
              )}
          </span>
          <div className="col-md-12 col-lg-12">
            <div className="col-3"></div>
            <div className="d-flex">
              <div className="mt-2">
                {patientId?.bedIsVacant === true ? (
                  <Button
                    disabled
                    text="Edit"
                    onClick={() =>
                      history.push(
                        `/bedRequests?appointmentId=${patientId?.appointmentId}`,
                        patientId
                      )
                    }
                  />
                ) : (
                  <Button
                    text="Edit"
                    onClick={() =>
                      history.push(
                        `/bedRequests?appointmentId=${patientId?.appointmentId}`,
                        patientId
                      )
                    }
                  />
                )}
              </div>
              <div className="m-2">
                {patientId?.bedIsVacant === true ? (
                  <Button
                    disabled
                    text="Mark Bed As Vacant"
                    onClick={() => handleBedVacant()}
                  />
                ) : (
                  <Button
                    text="Mark Bed As Vacant"
                    onClick={() => handleBedVacant()}
                  />
                )}
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    )
  }
  function renderCategoryStatement() {
    let statusCheck = AppointmentCalendarUtils.getAppointmentStatus(
      patientId?.status
    )
    return `${AppointmentCalendarUtils.getPatientAppointmentType(
      patientId?.patientAppointmentType
    )} appointment is ${statusCheck}`
  }

  function renderPatientChip() {
    const handleMaintainPayment = () => {
      addInvoiceLink(patientId?.invoiceId, payment)
        .then((res: any) => {
          setSendPaymentLink({
            type: "success",
            text: `Payment link sent to - ${patientId?.primaryPhoneNumber} via sms`,
          })
        })
        .catch((err) => {
          console.log(err?.response?.data?.message, "Payment Gatewayyy errrrrorrrrr");
          // setSendPaymentLink({
          //   type: "error",
          //   text: err?.response?.data?.message,
          // })
          setSendPaymentLink({
            type: "error",
            text: `Please specify the amount to send online link to patient`
          })
        })
    }

    return (
      <Popover
        id={id}
        open={opens}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        sx={{ width: "100%" }}
      >
        <div className="patient-detail-popover">
          <div className="card-view header-section">
            <div className="name">{patientId?.isVIP ? patientId?.mocId : patientId?.patientName}</div>
            <div className="patientId">{patientId?.mocId}</div>
            <div className="patientId">
              {patientId?.gender}{" "}
              {patientId?.dob ? calculateAge(patientId?.dob) : ""}
            </div>

            {patientId?.phoneNumber ? (
              <div className="phone-email">
                <img
                  className="icon"
                  src={"../../assets/images/phoneIcon.svg"}
                  alt="phoneIcon"
                />
                <div className="text">{patientId?.phoneNumber}</div>
              </div>
            ) : null}

            {patientId?.email ? (
              <div className="phone-email">
                <img
                  className="icon"
                  src={"../../assets/images/emailIcon.svg"}
                  alt="emailIcon"
                />
                <div className="text">{patientId?.email}</div>
              </div>
            ) : null}

            <div className="patientId">
              Primary Consultant: {smartSummary?.primaryConsultantName}
            </div>

            {/* <!-- Horizontal Stepper Wrapper --> */}
            {(userRole === MocUserRole.FRONT_DESK ||
              userRole === MocUserRole.RMO) &&
              renderHorizontalStepper()}
            {/* <!-- /.Horizontal Stepper Wrapper --> */}
          </div>

          {userRole === MocUserRole.NURSE && renderBedDetails()}

          <div className="card-view follow-up">
            <div
              style={{ marginRight: "50px" }}
              className="icon col-md-1 col-lg-1 p-0"
            >
              <img
                className="grey-filler"
                alt="followupIcon"
                src="../../assets/images/opd.svg"
              />
            </div>
            <div>
              <div className="header pt5">
                {AppointmentCalendarUtils.getPatientAppointmentType(
                  patientId?.patientAppointmentType
                )}
              </div>
              {userRole === MocUserRole.NURSE ? (
                ""
              ) : (
                <div className="description pt5">
                  with{" "}
                  <span className="title">{patientId?.consultantName || smartSummary?.primaryConsultantName}</span>
                </div>
              )}

              {/* <div className="description pt5">
                at{" "}
                {userRole !== MocUserRole.NURSE ? <span className="title">
                  {slots && slots[0]
                    ? moment(slots[0], "HH:mm").format("hh:mm a")
                    : null}
                </span> : <span className="title">

                  {NurseSlots && NurseSlots[0]
                    ? moment(NurseSlots[0], "HH:mm").format("hh:mm a")
                    : null}                </span>}




                {userRole !== MocUserRole.NURSE ? <span className="description">
                  {` for `}
                  {slots?.length * slotDuration}
                  {` mins`}
                </span> : <span className="description">
                  {` for `}
                  {NurseSlots?.length * slotDuration}
                  {` mins`}
                </span>}

              </div> */}

              {patientId?.appointmentType === "IPD" ? (
                <div className="description pt5">
                  <span className="description">Room:</span>
                  <span className="title ps-1">
                    {patientId?.allottedBed?.roomName}
                  </span>
                  <span className="description ps-2">Bed:</span>
                  <span className="title ps-1">
                    {patientId?.allottedBed?.bedName}
                  </span>
                </div>
              ) : null}

              <div className="header pt5">
                Category:{" "}
                <span className="description text-capitalize">
                  {renderCategoryStatement()}
                </span>
                <br />
                {patientId?.status === "NO_SHOW" && (
                  <div>
                    Reason:
                    <span>{patientId?.reason}</span>
                  </div>
                )}
              </div>
              {patientId?.bedIsVacant === true ? (
                <div className="header pt5">
                  <span>Bed Vacancy:</span>
                  <span className="description text-capitalize">
                    Bed Is Vacant
                  </span>
                </div>
              ) : (
                ""
              )}

              <div className="d-flex justify-content-space">
                <div className="header pt5">
                  <div>Notes:</div>
                </div>
                <div className="m-2">
                  <span>{patientId?.comments}</span>
                </div>
              </div>

              {patientId?.status !== "NO_SHOW" &&
                patientId?.status !== "CANCELLED" &&
                renderActionButtons()}
            </div>
          </div>

          {renderSmartSummarySection()}

          {userRole === MocUserRole.FRONT_DESK && (
            <div className="card-view button-section">
              {patientId?.appointmentType === "OPD" &&
                !patientId?.engageTime &&
                patientId?.status !== "NO_SHOW" && (
                  <>
                    {/* <div className="d-flex p-0 ipd-conversion">
                      <Button
                        text="Convert to IPD"
                        onClick={() =>
                          onPatientChipButtonClick({
                            source: "convertToIPD",
                            patient: patientId,
                          })
                        }
                        id="convert-to-ipd"
                      />
                    </div> */}



                    <div>
                      {!(
                        patientId?.arrivalTime === "Check in" ||
                        patientId?.arrivalTime === "Checked In" ||
                        patientId?.engageTime === "In Consultation" ||
                        patientId?.engageTime === "Consultation"
                      ) ||
                        patientId?.status === "Check out" ||
                        patientId?.status === "Checked out" ||
                        patientId?.status === "COMPLETED" ||
                        userRole === MocUserRole.HOME_CARE_RMO ||
                        userRole === MocUserRole.HOME_CARE_NURSE ? (
                        <div className="d-flex mt-2">
                          <label className="title mt-2">Enter The Amount :</label>
                          <InputField
                            handleChange={(e) => {
                              const newValue = parseFloat(e.target.value);
                              if (!isNaN(newValue) && newValue >= 0) {
                                setIsPayment(newValue);
                              }
                              else {
                                setIsPayment(0);
                              }
                            }}
                            type="number"
                            value={payment}
                          />
                        </div>
                      ) : null}
                    </div>
                  </>
                )}

              {patientId?.invoiceId && (
                <>
                  <div
                    className="col-md-12 col-lg-12 text-center sms-link"
                    onClick={() => handleMaintainPayment()}
                  >
                    Send the online payment SMS link to patient
                  </div>

                  <div className="col-md-12 col-lg-12 billing">
                    <Button
                      text="Bill / Payment"
                      onClick={() =>
                        onPatientChipButtonClick({
                          source: "billPayment",
                          patient: patientId,
                        })
                      }
                      id="bill-payment"
                    />
                  </div>
                  <div>
                    {sendpaymentLink && (
                      <Toast
                        textMessage={sendpaymentLink?.text}
                        onClose={() => {
                          setSendPaymentLink(false)
                        }}
                        onCloseText={"Close"}
                        type={sendpaymentLink?.type}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </Popover>
    )
  }

  function showSpr() {
    // setSpecialCalendar(true)
    return (
      <div>
        {userRole === MocUserRole.FRONT_DESK ||
          userRole === MocUserRole.NUTRITIONIST ||
          userRole === MocUserRole.GENETIC_COUNSELLOR ||
          userRole === MocUserRole.RMO ||
          userRole === MocUserRole.NURSE ||
          userRole === MocUserRole.PHYSIOTHERAPIST ? (
          ""
        ) : (
          <div className="d-flex">
            <div
              className="back-image"
              onClick={() => {
                setSpecialCalendar(false)
              }}
            >
              <img
                src="../../assets/images/back-icon.svg"
                height={"60px"}
                width={"60px"}
                alt="back button"
              />
            </div>
            <div className="mt-3" style={{ fontSize: "18px !important" }}>
              Special Request
            </div>
          </div>
        )}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>Patient ID</TableCell>
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>Consultant Name</TableCell>{" "}
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>Patient Name</TableCell>
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>Appointment Status</TableCell>
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>Appointment Type</TableCell>
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>From Time</TableCell>
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>To Time</TableCell>
                <TableCell align="center" className="Table" style={{
                  fontSize: "18px !important",
                  fontWeight: "bold"
                }}>Service Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tempSpl?.sort((a: any, b: any) => new Date(b.specialRequestFromTime).getTime() - new Date(a.specialRequestFromTime).getTime())
                ?.map((res) => (
                  <TableRow
                    className="cursor-pointer"
                    key={res?.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    onClick={() => {
                      if (specialCalendar) {
                        setshows(false)
                        setOpen(true)
                        setPatientId(res)
                      } else {
                        setshows(false)
                        setPatientId(res)
                        setSpecialCalendar(false)
                        setOpen(true)
                      }
                    }}
                  >
                    {/* <TableCell component="th" scope="row">
                    {res?.mocId}
                  </TableCell> */}
                    <TableCell align="center">{res.mocId}</TableCell>
                    <TableCell align="center">{res.consultantName}</TableCell>
                    <TableCell align="center">{res?.isVIP ? res?.mocId : res?.patientName}</TableCell>
                    <TableCell align="center">{res.status}</TableCell>
                    <TableCell align="center">
                      {res.patientAppointmentType}
                    </TableCell>
                    <TableCell align="center">
                      {res.specialRequestFromTime}
                    </TableCell>
                    <TableCell align="center">
                      {res.specialRequestToTime}
                    </TableCell>
                    <TableCell align="center">{res.serviceName}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
            {/* </div> */}
          </Table>
        </TableContainer>

        {renderPatientChip()}
      </div >
    )
  }




}
